var _g, _circle, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 1122,
    viewBox: "0 0 1441 1122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2664_11668)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2664_11668)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.0319,
    cy: 26.662,
    r: 790.5,
    transform: "rotate(39.0726 49.0319 26.662)",
    fill: "url(#paint0_linear_2664_11668)",
    fillOpacity: 0.05
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2664_11668)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_2664_11668_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.469884 0.381492 -0.381492 0.469884 -130.587 1.59037)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1003.72,
    y: -1003.72,
    width: 2007.43,
    height: 2007.43
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(41, 139, 201, 1) 0deg,rgba(135, 162, 199, 1) 97.0608deg,rgba(0, 98, 232, 1) 181.478deg,rgba(37, 138, 202, 1) 220.621deg,rgba(47, 111, 227, 1) 267.566deg,rgba(37, 138, 202, 1) 355.293deg,rgba(41, 139, 201, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -130.587,
    cy: 1.59037,
    r: 605.25,
    transform: "rotate(39.0726 -130.587 1.59037)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.53200417757034302,\"g\":0.63760507106781006,\"b\":0.78111368417739868,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"stopsVar\":[{\"color\":{\"r\":0.53200417757034302,\"g\":0.63760507106781006,\"b\":0.78111368417739868,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"transform\":{\"m00\":939.76861572265625,\"m01\":-762.98443603515625,\"m02\":-218.97949218750,\"m10\":762.98443603515625,\"m11\":939.76861572265625,\"m12\":-849.78613281250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2664_11668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 19,
    width: 1441,
    height: 1024
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.00049,
    y: 19,
    width: 1440,
    height: 1024,
    fill: "url(#paint2_linear_2664_11668)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2664_11668)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2664_11668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1271.9 607C1128.81 544 1096.61 449.339 917.495 436.368C738.385 423.397 525 182 380.077 140.095C235.154 98.1895 91.8833 149.482 -1.00049 221L-1.00049 927L1439 927L1439 669C1439 669 1414.99 670 1271.9 607Z",
    fill: "url(#paint3_linear_2664_11668)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1235.27 581C1072.17 559.267 1013.13 416.398 772.982 425C532.832 433.602 422.763 309 241.65 309C60.537 309 -1.00049 405 -1.00049 405L-1.00049 937L1439 937L1439 554C1439 554 1398.37 602.733 1235.27 581Z",
    fill: "url(#paint4_linear_2664_11668)",
    fillOpacity: 0.8
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2664_11668",
    x: -1041.49,
    y: -1063.86,
    width: 2181.05,
    height: 2181.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2664_11668"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2664_11668",
    x: -1335.86,
    y: -1203.68,
    width: 2410.54,
    height: 2410.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_2664_11668"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_2664_11668_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -130.587,
    cy: 1.59037,
    r: 605.25,
    transform: "rotate(39.0726 -130.587 1.59037)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2664_11668",
    x: -1.00049,
    y: 125,
    width: 1440,
    height: 802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2664_11668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2664_11668",
    x1: -741.468,
    y1: -763.837,
    x2: 1166.97,
    y2: 24.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2370CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2664_11668",
    x1: 1439,
    y1: 565,
    x2: -1.00041,
    y2: 563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31107,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720793,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2664_11668",
    x1: 733.124,
    y1: 145,
    x2: 733.124,
    y2: 687.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2664_11668",
    x1: 756.524,
    y1: 309,
    x2: 756.524,
    y2: 744.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2664_11668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1444,
    height: 1122,
    fill: "white",
    transform: "translate(-3.00049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBackground);
export default __webpack_public_path__ + "static/media/heroBackground.1d3c0c77729537c16e75faea76013020.svg";
export { ForwardRef as ReactComponent };